<template lang="pug">
.m-b-1
    include dynamic-filter-template.pug
</template>

<script>
import FilterList from '@js/components/filter/filter-list';
import RemoteSearchMixin from './remote-search-mixin';

export default {
    components: {
        FilterList,
    },

    mixins: [RemoteSearchMixin],

    data() {
        return {
            mode: 'buttons',

            externalRemotes: {},

            remoteResolver: null,

            preSelectOperator: false,

            preSelectOperatorData: {
                name: 'includes',
                display_name: 'includes',
                type: 'multiselect',
            },

            returnOperatorValueList: false,

            localFilters:
                !_.isNull(this.$store.getters.activeTableName) &&
                this.getActiveTableFilters()
                    ? this.getActiveTableFilters()
                    : _.isNull(this.$store.getters.activeTableName) &&
                      this.getTemporaryFilters()
                        ? this.getTemporaryFilters()
                        : [],

            // force custom filter to pass params to url
            allowAllSelectedColumns: ['Till Closure', 'Till Summary'],

            noSelectAllCheckbox: [],
        };
    },

    watch: {
        localFilters: function(newVal, oldVal) {
            if (this.checkLocalFilters(newVal, oldVal)) return;
            this.mockAllSelectedFilter(newVal);

            this.setFilters(
                newVal.filter(
                    f =>
                        (f.allSelected === true &&
                            this.allowAllSelectedColumns.includes(
                                f.filter_name,
                            )) ||
                        f.allSelected === false ||
                        _.isUndefined(f.allSelected),
                ),
            );
        },
    },

    created() {
        this.getCurrentFilters();
        window.addEventListener('beforeunload', this.clearTemporaryFilters);
    },

    methods: {
        apply() {
            this.$refs.filterList.validateAndApplyFilter();
        },

        createFilter() {
            this.$refs.filterList.createFilter();
            this.mode = 'addFilter';
        },

        onFilterCreated(filter) {
            this.mode = 'buttons';
        },

        onFilterEdit(filter) {
            this.mode = 'addFilter';
        },

        showSummary() {
            this.$refs.filterList.showSummary();
            this.mode = 'buttons';
        },

        getCurrentFilters() {
            if (!_.isEmpty(this.filters)) {
                this.localFilters = this.filters;
            }
        },

        checkLocalFilters(newVal, oldVal) {
            let a = newVal
                .map(v => v.list)
                .flat()
                .sort((a, b) => a - b);

            let b = oldVal
                .map(v => v.list)
                .flat()
                .sort((a, b) => a - b);

            if (JSON.stringify(a) === JSON.stringify(b)) {
                return true;
            } else {
                // for saveState = false, oldValue seems delay for some reason. use mutation to overcome this issue
                if (!this.$store.getters.oldActiveValue.length) {
                    this.$store.commit('setOldActiveValue', a);
                } else {
                    if (
                        JSON.stringify(a) ===
                        JSON.stringify(this.$store.getters.oldActiveValue)
                    ) {
                        return true;
                    } else {
                        this.$store.commit('setOldActiveValue', a);
                    }
                }
            }

            return false;
        },

        mockAllSelectedFilter(newVal) {
            this.clearTemporaryFilters();

            if (_.isNull(this.$store.getters.activeTableName)) {
                let filters = newVal.filter(
                    f =>
                        f.allSelected === true &&
                        !this.allowAllSelectedColumns.includes(f.filter_name),
                );

                if (!_.isEmpty(filters)) {
                    localStorage.setItem(
                        'temporary_filters',
                        JSON.stringify(filters),
                    );
                }
            }
        },

        getActiveTableFilters() {
            return JSON.parse(
                localStorage.getItem(
                    `${this.$store.getters.activeTableName}_filters`,
                ),
            );
        },

        getTemporaryFilters() {
            return JSON.parse(localStorage.getItem('temporary_filters'));
        },

        clearTemporaryFilters() {
            localStorage.removeItem('temporary_filters');
        },
    },
};
</script>

<style lang="scss" scoped>
.loading {
    line-height: 1;
    text-align: center;
}

.set-buttons {
    align-items: center;
    display: flex;
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/filter/dynamic-filter-base.vue